<template>
	

	<div class="settings">
		<app-header/>
		


		<div class="container">

			<div class="form-group">
				<label>Server Confirm Http</label>
				<input type="text" placeholder="http://platform.com/api/confirm/endpoint" name="" class="form-control">
			</div>

			<div class="form-group">
				<label>Bearer Token</label>

				<div class="row">
					<div class="col-md-10">
						<input type="text" placeholder="Put your Ultra secret token Here" v-model="token" class="form-control">
					</div>
					<div class="col-md-2">
						<button type="button" v-on:click="rand" class="btn btn-primary btn-sm">Generar</button>
					</div>
				</div>
			</div>


			<button type="submit" class="btn btn-primary">
				Guardar
			</button>


		</div>
		

		<app-footer/>	
	</div>
</template>


<script lang="ts">
import Vue from "vue";

import AppHeader from "@/components/AppHeader.vue";
import AppLoader from "@/components/AppLoader.vue";
import AppFooter from "@/components/AppFooter.vue";

export default Vue.extend({
  components: {
    AppHeader,
    AppLoader,
    AppFooter
  },
  data: function() {
    return {
      token: ""
    };
  },
  methods: {
    rand: function() {
      var a = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890$@()!".split(
        ""
      );
      var b = [];
      for (var i = 0; i < a.length; i++) {
        var j = (Math.random() * (a.length - 1)).toFixed(0);
        b[i] = a[j];
      }
      this.token = b.join("");
    }
  },

  mounted: function() {}
});
</script>


<style>
</style>
